<template>
  <v-card class="br-page-toolbar" elevation="0" outlined>
    <v-card-text class="br-page-toolbar__body">
      <div v-if="$slots.filters" class="br-page-toolbar__filters">
        <slot name="filters" />
      </div>

      <div v-if="$slots.actions" class="br-page-toolbar__actions">
        <slot name="actions" />
      </div>

      <v-divider
        v-if="($slots.filters || $slots.actions) && $slots.default"
        class="br-page-toolbar__divider"
      />

      <div v-if="$slots.default" class="br-page-toolbar__extra">
        <slot />
      </div>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "PageToolbar",
});
</script>

<style scoped lang="scss">
@import "@/assets/scss/design-system/tokens";

.br-page-toolbar {
  border-radius: $br-radius-xl !important;
  border-color: $br-border-soft !important;
  background: linear-gradient(180deg, $br-bg-elevated 0%, $br-bg-subtle 100%) !important;
  box-shadow: $br-shadow-sm !important;
  margin-bottom: $br-space-4;
}

.br-page-toolbar__body {
  padding: $br-space-3 $br-space-4 $br-space-3 !important;
}

.br-page-toolbar__filters,
.br-page-toolbar__actions {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: $br-space-2;
}

.br-page-toolbar__filters {
  flex: 1 1 240px;
  min-width: 0;
}

.br-page-toolbar__filters ::v-deep .v-input {
  width: 100%;
}

.br-page-toolbar__actions {
  justify-content: flex-end;
  margin-left: auto;
}

.br-page-toolbar__body {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: $br-space-2 $br-space-3;
}

.br-page-toolbar__divider {
  flex: 1 1 100%;
  margin: $br-space-2 0 !important;
  border-color: $br-border-soft !important;
}

.br-page-toolbar__extra {
  flex: 1 1 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: $br-space-1 $br-space-2;
}

@media (max-width: 959px) {
  .br-page-toolbar__actions {
    width: 100%;
    margin-left: 0;
    justify-content: flex-start;
  }
}
</style>
